import { render } from "./fail.vue?vue&type=template&id=5238cce1"
import script from "./fail.vue?vue&type=script&lang=js"
export * from "./fail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__